import * as React from "react";
import { StartsIn } from "../StartsIn";
export const KickOffState = (props) => {
    const kickOffTime = props.event.kickOffTime
        ? props.dict.ClockMins.format(props.event.kickOffTime)
        : "";
    return (React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__times`, "data-uat": `div-ev-list-${props.componentPrefix}-times` },
        React.createElement(StartsIn, { startsIn: props.dict.StartsIn, kickOffTime: kickOffTime, componentPrefix: props.componentPrefix })));
};
//# sourceMappingURL=KickOffState.js.map